export default function Marquee({ text, className = "" }) {
  const items = Array.from({ length: 3 });
  return (
    <div className={`relative w-full overflow-hidden py-8 md:py-12 ${className}`} data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {items.map((_, i) => (
          <span key={i} className="font-serif text-3xl md:text-5xl leading-none font-light px-6 flex items-center gap-6">
            {text}
            <span className="inline-block w-2.5 h-2.5 rounded-full bg-ochre align-middle shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
